"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCurrentPageReducer;

var _reduxResource = require("@flowio/redux-resource");

var _normalizeParameters2 = _interopRequireDefault(require("./normalizeParameters"));

function createCurrentPageReducer() {
  // eslint-disable-next-line default-param-last
  return function currentPageReducer() {
    var previousState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    var _normalizeParameters = (0, _normalizeParameters2.default)(action.meta),
        pageNumber = _normalizeParameters.pageNumber;

    switch (action.type) {
      case _reduxResource.actionTypes.REQUEST_FULFILLED:
        return pageNumber;

      default:
        return previousState;
    }
  };
}